import React, {useState, useEffect} from "react"
import { Row, Col, Button, Input  } from 'antd'
import classes from './styles.module.css'
import { useTranslation } from "react-i18next"
import HelmetComponent from '../../components/Helmet'
import Spinner from '../../components/PageComponents/Spinner'
import TitleAndSubtitle from '../../components/PageComponents/TitleAndSubtitle'
import { SearchOutlined } from '@ant-design/icons'


import CheckBoxRouteExplorationEventComponent from '../../components/CheckBoxGroup/CheckBoxRouteExplorationEvent'
import CheckBoxMunicipalityComponent from '../../components/CheckBoxGroup/CheckBoxMunicipality'

import ViewPointsComponent from './viewPoints'

import utils from '../../utils'

// Redux
import type { RootState } from '../../redux/store'
import { useSelector, useDispatch } from 'react-redux'
import { KeySearchRedux } from '../../redux/mapPage/search'
import { useSearch } from '../../hooks/useSearch'


const Search: React.FC = () => {

  const { t, i18n } = useTranslation()

  const [stringTemp, setStringTemp] = useState<string>("")
  const [searchString, setSearchString] = useState<string>('')
  const dispatch = useDispatch()


  const [poises, setPoises] = useState<any[]>([]);
  const [notFind, setNotFind] = useState<boolean>(false);
  const [setPoisesMarkerExploration, PoisesMarkerExploration] = useState<any[]>([]);
  const ReduxKey: string = useSelector((state: RootState) => state.Searches.Key)
  const ReduxSearch: any[] = useSelector((state: RootState) => state.Searches.Search)
  const ReduxMunicipalities: any[] = useSelector((state: RootState) => state.Searches.Municipality)


  const { isLoading, isFetching, SearchResultData, checkIfArrayEmpty, refetch } = useSearch(ReduxKey, i18n.language)


  useEffect(() => {
    if ( ReduxKey !== '' ) {
      refetch() 
    }
  }, [ReduxKey, i18n.language])


  useEffect(() => {

    setPoises(SearchResultData)
    
    let result = utils.filterSearchArray(SearchResultData, ReduxSearch, ReduxMunicipalities)
    // result.length > 0 ? setPoises(result) : setPoises([])
    if (result.length > 0) {
      setPoises(result)
      setNotFind(false)
    }
    else {
      setPoises([])
      setNotFind(true)
    }

    // console.log('SearchResultData :', SearchResultData)
    // console.log('ReduxSearch :', ReduxSearch)
    // console.log('ReduxMunicipalities :', ReduxMunicipalities)
    // }
   
    // window.scrollTo({ top: 200, left: 0, behavior: 'smooth' });

  },[ ReduxKey, SearchResultData, ReduxSearch, ReduxMunicipalities ])



  useEffect(() => { setNotFind(false) },[])

  const handleKeypress = (e : React.KeyboardEvent<HTMLInputElement>) => {
  
    if (e.key === 'Enter') {
      setSearchString(stringTemp)
      dispatch(KeySearchRedux(stringTemp))
    }
  };


  if (isFetching) {
    return (<Spinner />)
  }

  return (
    <>
      <HelmetComponent title='Αναζήτηση' descrition='Αναζήτηση' />
     
      <TitleAndSubtitle title={t('Αναζήτηση')} subTitle={t('')}/>

      <div className={classes.divSearchContainer}>
        <Row justify="center">
          <Col xs={24} sm={24} md={24} lg={{span: 8}}>
            
            <div className={classes.divIntoSearchContainer}>

              <span className={classes.searchInput}>
                <Input
                  size="large"
                  style={{height: '50px'}}
                  placeholder={searchString}
                  // value={searchString}
                  onChange={(e) => setStringTemp(e.target.value)}
                  onKeyPress={handleKeypress}
                  prefix={<SearchOutlined />} />
              </span>
           
              <span >
                <Button
                  type="primary" 
                  size='large'
                  className={classes.btnSearch}
                  onClick={()=> [setSearchString(stringTemp), dispatch(KeySearchRedux(stringTemp))]}><span className={classes.searchBtn}>{t('Αναζήτηση')}</span>
                </Button>
              </span>
        
            </div>
          </Col>
        </Row>
      </div>

      <div className={classes.MainContainer}>
        <Row justify="center">
        <Col xs={24} sm={24} md={5} lg={5}>
          <div className={classes.checkBoxesContainer}>
              <p className={classes.filters}>{t('Φίλτρα αναζήτησης')}</p>  
              <CheckBoxRouteExplorationEventComponent checkedId={ReduxSearch} />
              <CheckBoxMunicipalityComponent checkedId={ReduxMunicipalities} />
          </div>
        </Col>

        <Col xs={24} sm={24} md={19} lg={19}>
            <Row justify="center">
              
              <Col xs={24} sm={24} md={24} lg={24}>
              
                {poises.length > 0 ?
                  <>
                  <div className={classes.searchDiv}> {t('Αναζήτηση για')}: { ReduxKey }</div>
                    <ViewPointsComponent
                      lg={24}
                      xs={24}
                      array={poises}
                      total={poises.length}
                      isAddOrDelete={true}
                      setPoisesMarkerExploration={PoisesMarkerExploration}
                      onClickAddRemove={() => ''} />
                  </> 
                  :
                  (checkIfArrayEmpty && SearchResultData.length==0) ?

                    <div className={classes.dontHave}>
                      { t('Δεν βρέθηκαν αποτελέσματα')}
                    </div>
                    :
                    notFind ? 
                    <div className={classes.dontHave}>
                     { t('Δεν βρέθηκαν αποτελέσματα')}
                      </div>
                      : ''
                }  

            </Col>
          </Row>
        </Col>

        </Row>
      </div>
    </>
  )
}


export default Search
